import api from './api';
import Data from '@/common/data';
import util from '@/common/util';
// import chime from './twilio';
// import chime from './chime';
import facebook from './facebook';
import aiDialogFlow, { aiInit } from './chime/aiDialogFlow';
import advRegister from '@/components/sign-log/advertising-register/register.js';

const getChatYunTwilio = async function () {
    // if(Data.hasOpenTwilio){
    //     let res = await import("./twilio");
    //     return res.default;
    // }
    let res = await import('./chime');
    return res.default;
};

var facebook_cms_inst = {
    $el: null,
    $mount() {
        if (this.$el) {
            return;
        }
        let img = new Image();
        img.src =
            '//cdn.chime.me/image/fs/sitebuild/site-cms/chat-facebook-icon.png';
        img.style.width = '60px';
        img.style.height = '60px';
        img.style.position = 'fixed';
        img.style.right = '12px';
        img.style.bottom = '24px';
        img.style.top = 'auto';
        img.style.zIndex = 2147483644;
        img.style.borderRadius = '50%';
        img.style.overflow = 'hidden';
        this.$el = img;
    },
    $destroy() {}
};
const facebook_cms = {
    createIns() {
        return Promise.resolve(facebook_cms_inst);
    }
};

const chatFactory = {
    chime: getChatYunTwilio,
    facebook: facebook,
    chime_cms: getChatYunTwilio,
    facebook_cms
};
var chatPs;
const chat = {
    checkUserAction: function () {
        if (!chatPs) {
            if (window.sitePageAutoInit === false) {
                chatPs = Promise.resolve();
            } else {
                chatPs = util.getUserActionPs();
            }
        }
        return chatPs;
    },

    // 创建chat实例(反复调用时会销毁之前的实例, 永远只有一个chat实例:即chat.curChatIns)
    init: function (siteAppVm, globalData = {}, logOutFlag = false) {
        if (
            Data.isBot ||
            !util.isReallyUser ||
            (advRegister.isShow() &&
                Data.pageKey === 'listing' &&
                Data.isLandingPage)
        ) {
            return;
        }
        // 退出登录时重新初始化chat
        if (logOutFlag) {
            util.removeCookie('chatbox_visitor_session_id');
            util.removeCookie('chatbox_visitor_id');
        }
        // this.checkUserAction().then(() => {
        let config = globalData.chatAndCaptureForm || {};
        let showLauncher = config.showLauncher;
        let { CHAT_AGENT_ID } = siteAppVm.$store.state.page.page;
        //只有showLauncher为true的时候才显示chat-box,优先级最高
        if (showLauncher) {
            config.isMobile = util.isMobile;
            let params = {
                leadUserId:
                    (siteAppVm.$store.state.user.user &&
                        siteAppVm.$store.state.user.user.id) ||
                    '',
                sessionId: util.getCookie('chatbox_visitor_session_id') || '',
                agentId: Data?.agentCreator?.agentId || ''
            };
            // company site
            if (globalData.siteLevel === 1) {
                params.userId = globalData.ownerId;
                params.siteId = globalData.siteId;
            }
            // office site
            else if (globalData.siteLevel === 2) {
                params.officeId = globalData.ownerId;
                params.siteId = globalData.siteId;
            } else {
                params.userId = CHAT_AGENT_ID;
            }
            // 先通过接口拿到AI相关信息
            api.getVisitorToken(params).then(async res => {
                config = {
                    chatAgentId: CHAT_AGENT_ID,
                    chatType: 'chime',
                    ...config,
                    visitorEnable: res.visitorEnable,
                    visitLead: res.visitLead,
                    aiHeadurl: res.headurl,
                    aiHeadname: res.aiHeadname
                };
                // 如果开启了AI, 强制使用chime chat
                if (res.visitorEnable) {
                    if (!showLauncher) {
                        chat.destroyChat();
                        return;
                    }
                    config.chatType = 'chime';
                }
                // 如果配置了 facebook 使用 facebook
                else if (config.messenger) {
                    config.chatType = 'facebook';
                }

                // 维护sessionId, 这个sessionId变了重新触发aiflow
                if (config.visitLead && config.visitLead.id) {
                    var oldVistorId = util.getCookie(
                        'chatbox_visitor_session_id'
                    );
                    // 如果visitorId变了, 清空aiFlow相关本地数据
                    if (oldVistorId !== config.visitLead.sessionId) {
                        window.localStorage.removeItem('set-site-welcome');
                        window.localStorage.removeItem('set-listing-page');
                        window.localStorage.removeItem('set-site-followup');
                        window.localStorage.removeItem(
                            'set-site-followup_final'
                        );
                    }
                    util.setCookie(
                        'chatbox_visitor_session_id',
                        config.visitLead.sessionId,
                        30
                    );
                    util.setCookie(
                        'chatbox_visitor_id',
                        config.visitLead.id,
                        30
                    );
                }

                // 保存最新的配置
                chat.config = config;
                // 根据chatType, 拿到对应的chat代码

                var chatFact =
                    chatFactory[config.chatType + (util.inCms ? '_cms' : '')];
                if (!chatFact) {
                    return;
                }
                if (util.isFunction(chatFact)) {
                    chatFact = await chatFact();
                }
                if (chatFact) {
                    chatFact
                        .createIns(config, siteAppVm)
                        .then(instance => {
                            if (!instance) {
                                return;
                            }
                            chat.destroyChat();
                            chat.curChatIns = instance;
                            chat.onCreated();
                            instance.$mount();
                            document && document.body.appendChild(instance.$el);
                        })
                        .catch(err => {
                            console.log('chat init error:', err);
                        });
                }
            });
        } else {
            chat.destroyChat();
        }
        // });
        aiDialogFlow({ agentId: CHAT_AGENT_ID });
        aiInit();
    },

    // 销毁chat实例
    destroyChat: function () {
        if (chat.curChatIns) {
            chat.curChatIns.$el && chat.curChatIns.$el.remove();
            chat.curChatIns.$destroy();
        }
    },
    onCreated: function () {
        if (chat.onCreatedCallback) {
            chat.onCreatedCallback();
            chat.onCreatedCallback = undefined;
        }
    }

    // refreshUserInfo: function(user) {
    //     var action = () => {
    //         chat.curChatIns.user = user ? user : null;
    //     };
    //     // 避免 curChatIns 实例还未生成时导致 undefined 错误
    //     if (chat.curChatIns) {
    //         action();
    //     } else {
    //         chat.onCreatedCallback = action;
    //     }
    //     user && waitOpenAIChat && chat.openAIChat();
    // },
    // openAIChat() {
    //     if (!chat.curChatIns || !chat.config) {
    //         //no instance or no config=>delay
    //         return !(waitOpenAIChat = true);
    //     }
    //     if (chat.config.visitorEnable == false) {
    //         //is not ai mode
    //         return (waitOpenAIChat = false);
    //     }
    //     if (chat.config.visitorEnable && chat.curChatIns.user) {
    //         //ai mode & already login
    //         chat.curChatIns.openChatWindow();
    //         return !(waitOpenAIChat = false);
    //     }
    //     return !(waitOpenAIChat = true); //delay
    // }
};

export default chat;
